import styled, { css } from "styled-components";
import { sizes, spacingWithoutGap, colors, maxWidth, paddingLeft, paddingRight, composeEnhancers } from "../core/enhancers";
import { isObject } from "../core/helpers";
var internalEnhancer = composeEnhancers(maxWidth, paddingLeft, paddingRight);
var composedPublicEnhancer = composeEnhancers(sizes, spacingWithoutGap, colors);
var PageContainer = styled.div.withConfig({
  displayName: "PageContainer",
  componentId: "sc-1d3tiqt-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme,
      fluid = _ref.fluid,
      limitMaxWidthBreakpoint = _ref.limitMaxWidthBreakpoint;
  var pageContainerTokens = theme.componentsTokens.pageContainer,
      up = theme.breakpointsHelpers.up;
  var containerMaxWidth = fluid ? "100%" : pageContainerTokens.maxWidth;
  return css(["margin-left:auto;margin-right:auto;box-sizing:border-box;", " &&{", " ", "}"], internalEnhancer({
    theme: theme,
    maxWidth: containerMaxWidth,
    paddingLeft: pageContainerTokens.paddingX,
    paddingRight: pageContainerTokens.paddingX
  }), limitMaxWidthBreakpoint && isObject(containerMaxWidth) && limitMaxWidthBreakpoint in containerMaxWidth && css(["", "{", "}"], up(limitMaxWidthBreakpoint), maxWidth({
    theme: theme,
    maxWidth: containerMaxWidth[limitMaxWidthBreakpoint]
  })), composedPublicEnhancer);
});
export default PageContainer;